export default __webpack_public_path__ + "../img/d_g280_g_print_00236.jpg";